import commonMessages from '@/store/common-modules/messages';

export default {
  namespaced: true,
  modules: {
    commonMessages,
  },
  getters: {
  },
  actions: {
  },
};
